export enum ImgStatusEnum {
  maxSizeExceeded = 'maxSizeExceeded',
  maxDimentionsExceeded = 'maxDimentionsExceeded',
  wrongAspectRatio = 'wrongAspectRatio',
  wrongFileType = 'wrongFileType',
  success = 'success',
}
